// Modules

import axios from 'axios'

// Mixins
import getEvent from "@/mixins/getEvent";

export default {
    mixins: [getEvent],
    methods: {
        async manageEvent(eventId, status, token) {
            this.isSending = true

            const mailData = {
                status: status,
                id: eventId,
                type: 'user-confirmation',
                message: this.message,
                token: token
            }

            await axios
                .post(
                    '/.netlify/functions/mailsender',
                    JSON.stringify({
                        mailData,
                    })
                )
                .then(function (response) {
                    console.log(response)
                })
                .catch(function (error) {
                    console.log(error)
                    alert('Es ist ein Fehler aufgetreten, bitte schicke den aktuellen Link an mail.@nativv.ch')

                })
            this.isSending = false
            this.$emit('update')
            this.getEvent(this.eventId);
        },

    }
}